export default "__VITE_ASSET__DQ_u7Oso__"